"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChunkTransform = void 0;
exports.chunk = chunk;
var _nodeStream = require("node:stream");
class ChunkTransform extends _nodeStream.Transform {
  chunk = [];
  constructor(maxChunkSize, options = {}) {
    // Sanitize config
    maxChunkSize = parseInt(maxChunkSize);
    if (isNaN(maxChunkSize)) {
      throw new RangeError(`maxChunkSize must be a number`);
    }
    if (maxChunkSize < 1) {
      throw new RangeError(`maxChunkSize must be at least 1`);
    }
    // Initialize
    super({
      objectMode: true,
      ...options
    });
    this.maxChunkSize = maxChunkSize;
  }
  _transform(chunk, _encoding, callback) {
    if (this.chunk.push(chunk) >= this.maxChunkSize) {
      this.push(this.chunk);
      this.chunk = [];
    }
    callback();
  }
  _flush(callback) {
    if (this.chunk.length > 0) {
      this.push(this.chunk);
    }
    callback();
  }
}
exports.ChunkTransform = ChunkTransform;
function chunk(chunkSize) {
  return new ChunkTransform(chunkSize);
}